import {RootState} from '../../store';
import {MeteringRecord} from './types';

export const selectionSelector = (state: RootState): Record<string, MeteringRecord> =>
    state['metering-records'].selection;
